<template>
    <div class="location-partners">
        <!--<pre v-text="$props"></pre>-->
        <!--<pre v-text="$attrs"></pre>-->

        <span class="location-partners--title" v-text="content.title"></span>
        <div class="location-partners--wrap">
            <ul class="u-reset location-partners--items">
                <li class="location-partners--item"
                        v-for="(partner, partnerIdx) in content.partners" :key="partnerIdx">
                    <img class="location-partners--logo" :src="partner.image.url" :alt="partner.image.alt">
                </li>
            </ul>
        </div>

        <!-- <pre v-if="content" v-text="content"></pre> -->
    </div>
</template>

<script>
    import cmsPluginMixin from 'framework/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPluginMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/location-partners/index.vue?6aacdce2